import { useBackgroundQuery, useReadQuery } from "@apollo/client/react";

import type { BackgroundQueryRef } from "../../../common/graphql/types/BackgroundQueryRef";
import type { GoodsTypesQueryQuery } from "../../../gql/graphql";
import { goodsTypesQuery } from "../graphql/GoodsTypesQuery";

export interface GoodsTypesQueryRefProps {
  goodsTypesQueryRef: BackgroundQueryRef<GoodsTypesQueryQuery>;
}

export const useGoodsTypesBackgroundQuery =
  (): BackgroundQueryRef<GoodsTypesQueryQuery> => {
    const [queryRef] = useBackgroundQuery(goodsTypesQuery, {
      fetchPolicy: "cache-first",
    });

    return queryRef;
  };

export const useGoodsTypes = (
  queryRef: BackgroundQueryRef<GoodsTypesQueryQuery>,
  options?: {
    includeInvalidGoodsTypes?: boolean;
  },
) => {
  const { data, error } = useReadQuery(queryRef);

  return {
    goodsTypes: (data?.viewer.goodsTypes.all ?? []).filter(
      (c) => options?.includeInvalidGoodsTypes || c.isValid,
    ),
    error,
  };
};
